import styled from '@emotion/styled';

const FormLabeledGroup = styled.div`
  display: grid;
  grid-row-gap: 8px;
`;

export default FormLabeledGroup;
